<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Planes Y Coberturas Seguro De Vehículo
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="objModal.abrirDialogo=true; objPlanCobertura.opcion='I'">Nuevo</v-btn>
        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-xl>
                <v-row dense>
                    <v-col cols="12">
                        <modalComponent :abrirDialogo="objModal.abrirDialogo" :titulo="objModal.titulo"
                            :listGeneral="listGeneral" :objPlanCobertura="objPlanCobertura" :parametros="parametros" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Aseguradora *" color="textbox"
                            v-model="objPlanCoberturaBusqueda.idAseguradora" :items="listGeneral.listaAseguradora"
                            @change="onListarProductos" item-text="aseguradora" item-value="idAseguradora" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Producto *" color="textbox" v-model="objPlanCoberturaBusqueda.idProducto"
                            :items="listGeneral.listaProductos" item-value="id_producto" item-text="nombre_producto"
                            @change="onListarPlanesProductos" outlined dense />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Estado *" color="textbox" v-model="objPlanCoberturaBusqueda.idEstado"
                            :items="listGeneral.listEstados" item-text="nombre_estado" item-value="id_estado" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Seguro" :placeholder="objPlanCoberturaBusqueda.seguro" filled dense disabled />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Naturaleza" :placeholder="objPlanCoberturaBusqueda.naturaleza" filled dense disabled />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Regulación" :placeholder="objPlanCoberturaBusqueda.regulacion" filled dense disabled />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="objPlanCoberturaBusqueda.busqueda" clearable prepend-inner-icon="search" dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :search="objPlanCoberturaBusqueda.busqueda" :headers="listGeneral.cabecera"
                            :items="listGeneral.detalle" class="elevation-3">

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editarPlanCobertura(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-text="objPlanCoberturaBusqueda.busqueda"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        name: 'PlanesCoberturasSeguroView',
        components: {
            modalComponent: () => import('@/components/constructor/ModalPlanCoberturaSeguroComponent.vue')
        },
        data: () => ({
            objModal: {
                abrirDialogo: false,
                titulo: 'Nuevo Plan Cobertura Vehículo'
            },
            objPlanCoberturaBusqueda: {
                opcion: 'L',
                idEstado: '1'
            },
            objPlanCobertura: {},
            listGeneral: {},
            parametros: {}
        }),
        created() {
            this.reset();
            axios.post(`${BASE_URI}administrador/planCobertura/cargaGeneral`,{})
                 .then((r) =>{
                     if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                     if(_.size(_.get(r,['data','data'],[])) == 0) throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion);
                        this.cargaGeneral(r.data);
                 })
                 .catch((e)=>{
                     mensajesAlerta(e,'E');
                 });
        },
        methods: {
              onListar(ruta, objeto, lista) {
                return axios.post(`${BASE_URI}${ruta}`, objeto)
                    .then((r) => {
                        if (r.status != 200 && r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if ((_.size(_.get(r,['data','data'],[])) > 0) && !_.isNull(lista))
                                _.set(this.listGeneral, lista, r.data.data);
                            else
                                mensajesAlerta(r.data.mensaje, 'I');

                        return r;
                    })
                    .catch((e)=>{
                        return e;
                    });
            },
            cargaGeneral(response){
                this.listGeneral = response.data.listas;
                this.parametros  = response.data.parametros;
                this.objPlanCoberturaBusqueda.idEstado = _.toString(this.parametros.idEstadoDefault);
                this.objPlanCobertura.idEstado = _.toString(this.parametros.idEstadoDefault);
                this.objPlanCoberturaBusqueda.idAseguradora = this.listGeneral.listaAseguradora[0].idAseguradora;

                var objeto = _.merge({},{opcion:'L_COMBO'},
                                        _.pick(this.objPlanCoberturaBusqueda,['idAseguradora','idProducto']),
                                        _.pick(this.objPlanCobertura,['idEstado'])
                                    );

                this.onListar('administrador/producto/listar', objeto, 'listaProductos')
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) > 0) {
                            this.objPlanCoberturaBusqueda.idProducto = this.listGeneral.listaProductos[0].id_producto;
                            return this.onListarPlanesProductos("e");
                        }
                    }).catch((e) => {
                        mensajesAlerta(e, 'E');
                    });
            },
            reset() {
                this.objPlanCobertura = { opcion: 'L', rango: false, idEstado: this.parametros.idEstadoDefault };
                this.objModal.titulo = 'Nuevo Plan Cobertura Vehículo';
                this.objModal.abrirDialogo = false;
                this.listGeneral.subDetalle = [];
            },          
            onListarProductos(e) {
                if (!_.isUndefined(e)) {
                    var objeto = _.merge({},{opcion:'L_COMBO'},
                                        _.pick(this.objPlanCoberturaBusqueda,['idAseguradora']),
                                        _.pick(this.objPlanCobertura,['idEstado'])
                                    );

                    this.$set(this.listGeneral, 'detalle', []);
                    this.$set(this.listGeneral, 'listaProductos', []);
                    this.$set(this.objPlanCoberturaBusqueda, 'idProducto', null);
                    this.$set(this.objPlanCoberturaBusqueda, 'seguro', null);
                    this.$set(this.objPlanCoberturaBusqueda, 'naturaleza', null);
                    this.$set(this.objPlanCoberturaBusqueda, 'regulacion', null);

                    this.onListar('administrador/producto/listar', objeto, null)
                        .then((r) => {
                            if (_.size(_.get(r,['data','data'],[])) > 0) 
                                _.set(this.listGeneral, 'listaProductos', r.data.data);
                        }).catch((e) => {
                            mensajesAlerta(e, 'E');
                        });
                }
            },
            onListarDetalleProducto() {
                var objeto = {
                    opcion: 'DETALLE',
                    idPlanProducto: this.objPlanCoberturaBusqueda.idPlanProducto,
                    idProducto: this.objPlanCoberturaBusqueda.idProducto,
                    idTipoPlan: this.objPlanCoberturaBusqueda.idTipoPlan,
                    idEstado: this.objPlanCoberturaBusqueda.idEstado
                };

                return this.onListar('administrador/producto/listar', objeto, null)
                    .then((r) => {
                        if (_.size(_.get(r,['data','data'],[])) > 0)
                            this.objPlanCoberturaBusqueda = _.merge({}, this.objPlanCoberturaBusqueda, r.data.data[0]);

                        return r;
                    });
            },
            onListarPlanesProductos(e) {
                if (!_.isUndefined(e)) {
                    return this.onListarDetalleProducto()
                        .then((respuesta) => {
                            this.$set(this.listGeneral, 'detalle', []);
                            this.objPlanCobertura = _.merge({}, this.objPlanCobertura, this
                                .objPlanCoberturaBusqueda);
                            var objeto = {
                                opcion: 'L',
                                idPlanProducto: this.objPlanCobertura.idPlanProducto,
                                idProducto: this.objPlanCobertura.idProducto,
                                idTipoPlan: this.objPlanCobertura.idTipoPlan,
                                idEstado: this.objPlanCobertura.idEstado
                            };
                            
                            return this.onListar('administrador/planCobertura/listar', objeto, null)
                        })
                        .then((respuesta) => {
                            _.forEach(respuesta.data.data, (dato, key) => {
                                this.listGeneral.detalle.push({
                                    idPlanProducto: dato['id_plan_producto'],
                                    idProducto: dato['id_producto'],
                                    nombre: dato['nombre_plan'],
                                    idTipoPlan: dato['idTipoPlan'],
                                    nombreEstado: dato['nombre_estado'],
                                    idSeleccionCoberturaCliente: dato[
                                        'id_seleccion_cobertura_cliente'],
                                    seleccionCoberturaCliente: dato['seleccion_cobertura_cliente'],
                                    idEstado: dato['id_estado']
                                });
                            });
                        })
                        .catch((e) => {
                            mensajesAlerta(e, 'E');
                        });
                }
            },
            editarPlanCobertura(obj) {
                this.objPlanCobertura = _.merge(_.omit(this.objPlanCoberturaBusqueda, ['opcion', 'evento', 'seguro',
                    'naturaleza', 'regulacion'
                ]), obj);
                this.objPlanCobertura.opcion = 'DETALLE';
                this.objModal.titulo = 'Editar Plan Cobertura Vehículo';
                this.objPlanCobertura.opcion = 'U';
                this.objModal.abrirDialogo = true;
            },
            insertarActualizar(objeto) {
                this.objPlanCobertura = _.merge({}, this.objPlanCobertura, objeto);

                axios.post(`${BASE_URI}administrador/planCobertura/insertOrUpdate`, {
                    opcion: this.objPlanCobertura.opcion,
                    idPlanProducto: this.objPlanCobertura.idPlanProducto,
                    idProducto: this.objPlanCobertura.idProducto,
                    nombre: this.objPlanCobertura.nombre,
                    idTipoPlan: this.objPlanCobertura.idTipoPlan,
                    seleccionCoberturaCliente: this.objPlanCobertura.seleccionCoberturaCliente,
                    idEstado: this.objPlanCobertura.idEstado,
                    listaCoberturas: this.listGeneral.subDetalle
                }).then((respuesta) => {
                    if (respuesta.status == 200 && respuesta.statusText == 'OK') {
                        if (!respuesta.data.existeError) {
                            if (_.size(respuesta.data.data) > 0) {
                                this.objModal.abrirDialogo = !this.objModal.abrirDialogo;
                                this.objModal.titulo = 'Nuevo Plan Cobertura Vehículo';
                                // this.objPlanCobertura = _.merge(this.objPlanCoberturaBusqueda,this.objPlanCobertura);
                                this.objPlanCobertura = {};
                                mensajesAlerta(respuesta.data.mensaje, 'S');
                                this.onListarPlanesProductos('e');
                            } else
                                mensajesAlerta(respuesta.data.mensaje, 'I');
                        } else
                            mensajesAlerta(respuesta.data.mensaje, 'E');
                    }
                }).catch((e) => {
                    mensajesAlerta(mensajeEstandar.errorPeticion, 'E');
                });
            },
            cerrarModal() {
                this.reset();
            }
        },
        provide() {
            return {
                insertarActualizar: this.insertarActualizar,
                onListarProductos: this.onListarProductos,
                cerrarModal: this.cerrarModal
            }
        },
    }
</script>